import { Directive, HostListener, ElementRef, Output, EventEmitter } from "@angular/core";

@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective {
    constructor(private _elementRef: ElementRef) {
    }

    @Output()
    public clickOutside = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);

        if (!clickedInside && !targetElement.attributes.getNamedItem('aria-dropdown')) {
            this.clickOutside.emit(null);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/click-outside/click-outside.directive.ts